<template>
    <div class="circle_container">
 
        <div :style="circleSize" class="prog-circle">
            <svg viewBox="0 0 100 100">
                <path :d="pathString" :stroke="trailColor" :stroke-width="strokeWidth" :fill-opacity="0"/>
                <path :d="pathString" :stroke-linecap="strokeLinecap" :stroke="strokeColor" :stroke-width="strokeWidth" fill-opacity="0" :style="pathStyle"/>
            </svg>
            <div class="prog-circle-inner">
                <slot>
    				<h3 class="prog-pre" v-if="jindu">{{ jindu }}%</h3>
    				<h3 class="prog-pre" v-else>{{ jindu }}%</h3>
    			</slot>
            </div>
        </div>
 
    </div>
</template>
 
<script type="text/ecmascript-6">
const prefixCls = 'prog-circle';
export default {
    props: {
        list: {
            type: Number,
            default: 0
        },
        jindu: {
            type: Number,
            default: 0
        },
        strokeWidth: {
					type: Number,
					default: 1,//描宽
        },
        size: {
            type: Number,
            default: 2
        },
				rem:{
					type:Boolean,
					default:true,//默认为rem
				},
        strokeColor: {
            type: String,
            default: '#ffcb63',//描色
        },
        strokeLinecap: {
						type:String,
            default: 'square',//['square', 'round']
        },
        trailColor: {
            type: String,
            default: '#efefef',//底色
        }
    },
    data () {
		return {
			percent:0
		}
    },
    computed: {
        circleSize () {
					if(this.rem){
						return {
							width: `${this.size}rem`,
							height: `${this.size}rem`
						};
					}else{
						return {
							width: `${this.size}px`,
							height: `${this.size}px`
						};
					}   
        },
        radius () {
            return 50 - 6 / 2;
        },
        pathString () {
            return `M 50,50 m 0,-${this.radius}
            a ${this.radius},${this.radius} 0 1 1 0,${2 * this.radius}
            a ${this.radius},${this.radius} 0 1 1 0,-${2 * this.radius}`;
        },
        len () {
            return Math.PI * 2 * this.radius;
        },
        pathStyle () {
            return {
                'stroke-dasharray': `${this.len}px ${this.len}px`,
                'stroke-dashoffset': `${((100 - this.percent) / 100 * this.len)}px`,
                //'transition': 'stroke-dashoffset 0.5s ease 0s, stroke 0.65s ease'
            };
        },
    },
    created() {
       //setTimeout(()=>{
            this.percent = this.list;
        //},700);
    },
  	methods: {
  	},
		
}
</script>
 
<style rel="stylesheet/scss" lang="scss" scoped>
    .clearfix{zoom: 1;}
    .clearfix:after{
        content: '';
        display: block;
        height: 0;
        visibility: hidden;
        clear: both;
    }
    .circle_container{
        width: 100%;
        position: relative;
    }
    .prog-circle-inner {
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        line-height: 1;
    }
    .prog-circle {
        display: inline-block;
        position: relative;
    }
</style>
